import { Controller } from "@hotwired/stimulus";

export class HelpBeaconController extends Controller {
  open(event) {
    event.preventDefault();
    if (typeof window.Beacon === "function") {
      window.Beacon("open");
    }
  }
}
